import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=bb4b44cc&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"
import style1 from "./Services.vue?vue&type=style&index=1&id=bb4b44cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4b44cc",
  null
  
)

export default component.exports